export default "__VITE_ASSET__d7beedb7__"